import { inject } from "@angular/core";
import { Auth, authState } from "@angular/fire/auth";
import { CanMatchFn, RedirectCommand, Router } from "@angular/router";
import { map } from "rxjs";

type Options = {
  needsAuthentication: boolean,
  redirectTo: string[],  
}

export const authGuard = (options: Options): CanMatchFn => () => {
  const { needsAuthentication, redirectTo } = options;
  const router = inject(Router);
  const auth = inject(Auth);
  const redirect = new RedirectCommand(router.createUrlTree(redirectTo))
  return authState(auth).pipe(
    map(Boolean),
    map(isAuthenticated => {
      const allowed = isAuthenticated === needsAuthentication;
      return allowed || redirect;
    }));
}